// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__12PjE","head":"ProcedureTableInfo_head__2Uy7-"};